import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';

import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexNonAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTooltip,
  ApexStroke,
  ApexYAxis,
  ApexFill,
  ApexPlotOptions,
  ApexLegend
} from "ng-apexcharts";

declare const WOW: any;

export type SourcesChart = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  legend: ApexLegend;
  plotOptions: ApexPlotOptions;
};

export type AnalysisChart = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  tooltip: ApexTooltip;
  dataLabels: ApexDataLabels;
  yaxis: ApexYAxis;
  fill: ApexFill;
  legend: ApexLegend;
};

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styles: []
})
export class SearchComponent implements OnInit, AfterViewInit {
  ngAfterViewInit(): void {
    new WOW().init();
  }

  public query = null;
  public data = null;
  public number_of_scores = 0;

  @ViewChild('chart') chart: ChartComponent;
  public sourcesChart: Partial<SourcesChart>;
  public analysisChart: Partial<AnalysisChart>;

  constructor(private route: ActivatedRoute, private api: ApiService) {}

  ngOnInit() {
    this.data = null;
    this.route.queryParams
      .subscribe(params => {
        this.query = params.query.trim();
        this.searchData(this.query);
      });
  }
  
  searchData(str) {
    this.data = null;
    this.api.search(str).subscribe(response => {

      response.analysis_group_by_day = {};
      for(let analysisI in response.analysis) {

        if(!response.analysis_group_by_day[response.analysis[analysisI].date.substr(0, 10)]) {
          response.analysis_group_by_day[response.analysis[analysisI].date.substr(0, 10)] = [];
        }
        response.analysis_group_by_day[response.analysis[analysisI].date.substr(0, 10)].push(response.analysis[analysisI]);


      }


      this.data = response;
      let sourcesTypes = [];
      let sourcesSeries = [];
      for (let type in response.sources_summary) {
        sourcesTypes.push(type);
        sourcesSeries.push(response.sources_summary[type]);
      }
      this.sourcesChart = {
        series: sourcesSeries,
        chart: {
          type: "donut",
          height: 250,
          width: 250
        },
        labels: sourcesTypes,
        legend: {
          position: 'bottom',
          fontSize: '12px',
          fontFamily: 'TextMeOne',
          labels: {
            useSeriesColors: true
          },
          formatter: (seriesName, opts) => {
            return '&nbsp;' + opts.w.globals.series[opts.seriesIndex] + ' ' + seriesName
          }
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              size: '55%'
            }
          }
        }
      };
      let analysisSeries = [];

      let tmp = [];
      for(let id in response.analysis_group_by_day) {
        let sum = 0;
        let count = 0;
        let avg = 0;
        for (let a of response.analysis_group_by_day[id]) {
          sum += a.score;
          count++;
        }
        if(count > 0 && sum > 0) {
          avg = Math.round((sum/count)*100);
        }
        tmp.push({ x: new Date(id), y: avg })
        
      }
      this.number_of_scores = tmp.length;
      analysisSeries.push({name: 'average-score', data: tmp});


      this.analysisChart = {
        series: analysisSeries,
        chart: {
          type: "line",
          height: 200,
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "straight"
        },
        xaxis: {
          type: "datetime",
          axisBorder: {
            show: false
          }
        },
        yaxis: {
          max: 100,
          min: 0,
          tickAmount: 4,
          floating: false,
          labels: {
            style: {
              colors: "#8e8da4"
            }
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        fill: {
          opacity: 0.5
        },
        tooltip: {
          x: {
            format: "dd MMMM yyyy"
          },
          fixed: {
            enabled: false,
            position: "topRight"
          }
        },
        legend: {
          show: true
        }
      };
    }, error => {
      this.data = false;
      console.error(error);
    });
  }

  shorten(str) {
    if (str.length <= 45)
      return str;
    return str.slice(0, 20) + '[...]' + str.slice(-20);
  }
}
